import { Injectable } from '@angular/core';
import { DialogService } from '@teammood/shared/ui/dialog';
import { ModerationDialogComponent } from '../timeline-item/moderation/moderation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ThreadDialogService {
  constructor(
    private _dialogService: DialogService,
  ) {
  }

  async delete() {
    return await this._dialogService.openConfirmDialog({
      title: 'delete',
      message: 'thread_deletation_confirmation',
      confirmBtnLabel: 'delete',
      confirmBtnType: 'danger'
    });
  }

  async moderate() {
    return await this._dialogService.open(ModerationDialogComponent, {
      width: '100%',
      maxWidth: '1100px',
    });
  }
}